export default "__VITE_ASSET__Bi2D7e6$__"